import React, { useContext, useEffect } from "react";
import NeurologicalSystem from "./NeurologicalSystem";
import Respiratory from "./Respiratory";
import CardioVascular from "./CardioVascular";
import Orthopedic from "./Orthopedic";
import Trauma from "./Trauma";
import Malignancy from "./Malignancy";
import { Col, Divider, Row } from "antd";

const ClinicalImpressionForm = ({
  form = {},
  context,
  editId,
  patientData,
}) => {
  const { formData } = useContext(context);

  useEffect(() => {
    const dataToSet = formData?.clinical_diagnosis || formData;

    if (dataToSet && Object.keys(dataToSet).length > 0) {
      form.setFieldsValue(dataToSet);
    }
  }, [formData, editId, form]);

  return (
    <>
      <Row>
        <Col span={24}>
          <NeurologicalSystem context={context} form={form} />
        </Col>
      </Row>
      <Divider />

      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Respiratory context={context} form={form} />
        </Col>
        <Col xs={24} md={12}>
          <CardioVascular context={context} form={form} />
        </Col>
      </Row>
      <Divider />

      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Orthopedic />
        </Col>
        <Col xs={24} md={12}>
          <Trauma context={context} form={form} />
        </Col>
      </Row>

      <Divider />
      <Malignancy />
    </>
  );
};

export default ClinicalImpressionForm;
